/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Roleid1Inputs */

const en_entity_roleid1 = /** @type {(inputs: Entity_Roleid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role ID`)
};

const de_entity_roleid1 = /** @type {(inputs: Entity_Roleid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rollen-ID`)
};

/**
* | output |
* | --- |
* | "Role ID" |
*
* @param {Entity_Roleid1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_roleid1 = /** @type {((inputs?: Entity_Roleid1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Roleid1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_roleid1(inputs)
	return de_entity_roleid1(inputs)
});
export { entity_roleid1 as "entity_roleId" }